import { defineStore } from 'pinia'
import { reactive, ref, watch } from 'vue'
import { useFilters } from '@/components/jobs/filters'
import { usePagination } from '@/components/jobs/pagination'
import { useJobsCountQuery, useJobsQuery } from '@/components/jobs/query'
import { JobSearchResponse } from '@/models/types/job-search-response'

export const useJobListStore = defineStore('job-list', () => {
  const selectedJobs = ref<JobSearchResponse[]>([])
  const isBulkUpdateFormOpen = ref(false)
  const isBulkUpdateBottomSheetOpen = ref(false)
  const itemsPerPage = ref(20)

  const updateSelectedJobs = (newJobs: JobSearchResponse[]) => {
    selectedJobs.value = newJobs
  }
  const updateIsBulkUpdateFormOpen = (newValue: boolean) => {
    isBulkUpdateFormOpen.value = newValue
  }
  const updateIsBulkUpdateBottomSheetOpen = (newValue: boolean) => {
    isBulkUpdateBottomSheetOpen.value = newValue
  }
  const updateItemsPerPage = (newValue: number) => {
    itemsPerPage.value = newValue
    query.limit = newValue
  }

  const filters = useFilters()
  const { getCurrentPage, updatePage } = usePagination()
  const query = reactive(useJobsQuery(filters, getCurrentPage, itemsPerPage))
  const countQuery = reactive(useJobsCountQuery(filters))

  watch(
    () => query.limit,
    (newLimit) => {
      updatePage(1)
      query.limit = newLimit
    },
  )

  watch(filters, () => {
    updatePage(1)
  })

  const updateQuerySortBy = (newValues: string[]) => {
    query.sortBy = newValues
  }
  const updateQuerySortDesc = (newValues: boolean[]) => {
    query.sortDesc = newValues
  }

  return {
    query,
    getCurrentPage,
    getItemsPerPage: itemsPerPage,
    selectedJobs,
    isBulkUpdateFormOpen,
    isBulkUpdateBottomSheetOpen,
    updateSelectedJobs,
    updateIsBulkUpdateFormOpen,
    updateIsBulkUpdateBottomSheetOpen,
    updateQuerySortBy,
    updateQuerySortDesc,
    updatePage,
    updateItemsPerPage,
    countQuery,
  }
})
